export default "__VITE_ASSET__DNsQhrUy__"